import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "supplier-announce-container" }
const _hoisted_2 = { class: "supplier-announce-summary-content" }
const _hoisted_3 = { class: "summary-area-header-content supplier-announce-summary-content__header" }
const _hoisted_4 = { class: "summary-area-header-content__title" }
const _hoisted_5 = { class: "summary-area-header-content__year-month-select" }
const _hoisted_6 = { class: "summary-area-body-container supplier-announce-summary-content__summary-area" }
const _hoisted_7 = { class: "summary-area-body-content" }
const _hoisted_8 = { class: "supplier-announce-table-area-container" }
const _hoisted_9 = { class: "supplier-announce-table-area-content" }
const _hoisted_10 = { class: "supplier-announce-table-area-header-container supplier-announce-table-content__header" }
const _hoisted_11 = { class: "supplier-announce-table-area-header-content" }
const _hoisted_12 = { class: "supplier-announce-table-area-body-container supplier-announce-table-content__body" }
const _hoisted_13 = { class: "supplier-announce-table-area-body-container__table--left" }
const _hoisted_14 = { class: "supplier-announce-table-area-body-container__table--right" }

import SimpleProgressRateTable from '@/corePagesModule/progressRateTableContent/pages/SimpleProgressRateTable.vue';
import SummaryCard from '@/corePagesModule/components/SummaryCard.vue';
import { OrganizationBusinessRepository } from '@/businessRepository/organizationBusinessRepository';
import { onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useSupplierForecastStore } from './useSupplierForecastStore';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import { i18n } from '@/i18n';

// 事前準備

export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierForecastDashboard',
  setup(__props) {

const organizationBusinessRepository = new OrganizationBusinessRepository();

// pinia
const supplierForecastStore = useSupplierForecastStore();
const { state } = storeToRefs(supplierForecastStore);
const { fetchState, updateTableData, checkBusiness } = supplierForecastStore;

const t = i18n.t;

onMounted(async () => {
  await fetchState(organizationBusinessRepository);
});

// 年月変更の監視
// 値が変わったら表示するテーブルを選択年月の情報に更新する
watch(
  () => state.value.selectYearMonthInfo,
  async () => {
    // テーブル表示に使用する情報を更新
    await updateTableData();
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('全体サマリ')), 1),
        _createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "summary-area-header-content__year-month-select--label" }, _toDisplayString('内示作成月'), -1)),
          _createVNode(MonthPicker, {
            "model-value": _unref(state).selectYearMonthInfo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).selectYearMonthInfo) = $event)),
            class: "summary-area-header-content__year-month-select--select",
            locale: 'ja'
          }, null, 8, ["model-value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: { name: 'all-businesses' } }, {
            default: _withCtx(() => [
              _createVNode(SummaryCard, {
                numerator: _unref(state).achieveCount,
                denominator: _unref(state).totalCount,
                "detail-info": '全取引',
                "display-detail-item-type": 'label'
              }, null, 8, ["numerator", "denominator"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(SummaryCard, {
            numerator: _unref(state).achieveNonResponsiveBusinessCount,
            denominator: _unref(state).totalNonResponsiveBusinessCount,
            "detail-info": '未割振取引',
            "display-detail-item-type": 'label'
          }, null, 8, ["numerator", "denominator"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(checkBusiness)()))
            }, _toDisplayString('確認用'))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(SimpleProgressRateTable, {
              "table-type": 'progressRateTableByRepPerson',
              items: _unref(state).displayUserBusinessList,
              "scroll-enable": true
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(SimpleProgressRateTable, {
              "table-type": 'progressRateTableBySupplier',
              items: _unref(state).displaySupplierBusinessList,
              "scroll-enable": true
            }, null, 8, ["items"])
          ])
        ])
      ])
    ])
  ]))
}
}

})